import React, { useReducer, useState, useEffect } from "react";
import PropTypes from "prop-types";
import TransactionHppTable from "../../elements/Tables/TransactionHppTable/TransactionHppTable";
import { useFetch } from "../../../Utils/useFetch";
import {
  FETCH_ALL_DEPT_API,
  FETCH_ALL_DISCOUNT_API,
  FETCH_ALL_TRANSACTION_API,
} from "../../../Constants/Apis";
import { Button, Input, message, Modal, Select, DatePicker, Form } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteTransaction } from "../../../Services/TransactionService";
import * as XLSX from "xlsx";

const { Search } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;

const TransactionHppPage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    departmentFilter: "",
    dateRange: [],
    filteredInfo: {},
    sorter: {},
    noSaleFlag: false,
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [transactionId, setTransactionId] = useState(null);
  const [modalForm] = Form.useForm();

  const handleDelete = async (id) => {
    setTransactionId(id);
    setIsModalOpen(true);
  };

  const handleCreate = () => {
    history.push("/user/create-transaction");
  };

  const handleOk = async () => {
    try {
      await deleteTransaction(transactionId);
      message.success("Transaction deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete transaction."
      );
    }
    setIsModalOpen(false);
  };

  const {
    fetchedData: { data },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_TRANSACTION_API}/article`, state);




  const {
    fetchedData: { data: discountData },
  } = useFetch(`${FETCH_ALL_DISCOUNT_API}`, state);

  const {
    fetchedData: { data: deptData = [] },
  } = useFetch(`${FETCH_ALL_DEPT_API}`, state);

  const handleSearch = (value) => {
    if (state.searchKeyword !== value) {
      dispatch({ type: "searchKeyword", payload: value });
      callReFetch();
    }
  };

  const handleDeptFilterChange = (value) => {
    if (state.departmentFilter !== value) {
      dispatch({ type: "departmentFilter", payload: value });
      callReFetch();
    }
  };

  const handleDateChange = (dates) => {
    const [startDate, endDate] = dates || [];
    const formattedStartDate = startDate
      ? startDate.format("YYYY-MM-DD")
      : null;
    const formattedEndDate = endDate ? endDate.format("YYYY-MM-DD") : null;

    const range = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };

    dispatch({ type: "dateRange", payload: {range} });
    callReFetch();
  };

  const handleDownloadExcel = () => {
    if (!data || data.length === 0) {
      message.warning("No transactions to download");
      return;
    }

    // Create header rows
    const headerRows = [
      {
        "Date Range":
          state.dateRange.startDate && state.dateRange.endDate
            ? `${state.dateRange.startDate} to ${state.dateRange.endDate}`
            : "All Dates",
      },
      {}, // Empty row
      {
        "Counter Name": "OUTLET",
        "Counter Code": "Kode Toko",
        "Transaction Date": "TANGGAL",
        "No Bon": "NOBON",
        Barcode: "barcode",
        Category: "kategori",
        Article: "BARANG",
        Size: "size",
        Division: "DivKecil",
        Quantity: "QTY",
        hpp: "HPP",
        Price: "HJUAL",
        totalBeforeDisc: "TOTAL",
        "Discount %": "DISC1",
        Total: "NETVAL",
      },
    ];

    const formattedData = data.map((item) => ({
      "Transaction Date": item.transactionDate
        ? new Date(item.transactionDate).toISOString().split("T")[0]
        : // .toISOString().split("T")[0]
          "N/A",
      "Counter Department": item.dept,
      "Counter Code": item.counterCode,
      "Counter Name": item.counterName,
      "No Bon": item.noBon,
      Division: item.articleDetails?.division,
      Category: item.articleDetails?.category,
      Barcode: item.barcode,
      Article: item.article,
      Quantity: item.quantity,
      Price: item.price ? item.price : 0,
      "Discount %": item.discount ? item.discount + "%" : "",
      Total: item.total ? item.total : 0,
      hpp: item.hpp ? item?.hpp : 0,
      totalBeforeDisc: item.totalBeforeDisc ? item.totalBeforeDisc : 0,
    }));

    // Combine header rows with data
    const allData = [...headerRows, ...formattedData];

    const worksheet = XLSX.utils.json_to_sheet(allData, { skipHeader: true });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");
    XLSX.writeFile(workbook, "hpp_report.xlsx");
  };

  return (
    <div
      style={{
        width: "100%",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowX: "hidden",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          maxWidth: "1200px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >

        <Select
          value={state.departmentFilter}
          style={{ width: "200px" }}
          onChange={handleDeptFilterChange}
        >
          <Option value="">All Departments</Option>
          {deptData.map((dept) => (
            <Option key={dept._id} value={dept.name}>
              {dept.name}
            </Option>
          ))}
        </Select>
        <RangePicker onChange={handleDateChange} />
        <Button type="default" onClick={handleDownloadExcel}>
          Download Excel
        </Button>
      </div>

      <TransactionHppTable
        history={history}
        loading={loading}
        data={data}
        callReFetch={callReFetch}
        dispatch={dispatch}
        handleDelete={handleDelete}
        discountData={discountData}
        modalForm={modalForm}
      />

      <Modal
        title="Delete Transaction"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this transaction?</p>
      </Modal>
    </div>
  );
};

TransactionHppPage.propTypes = {};

export default TransactionHppPage;
